import { BettingOfferStatus } from "@api-types/offer/offer-history/BettingOfferStatus";

const STATUS_CLASS_MAP: Partial<Record<BettingOfferStatus, string>> = {
	[BettingOfferStatus.Win]: "quote--success",
	[BettingOfferStatus.Refund]: "quote--warning",
};

export function getOfferHistoryStatusClass(status: BettingOfferStatus): string {
	return STATUS_CLASS_MAP[status] ?? "quote--default";
}
